import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import { MESSAGE_FIELDS } from '#/graphql/fragments/message-fields';
import type {
  GetMessagesQuery,
  GetMessagesQueryVariables,
} from '#/graphql/generated';

export const GET_MESSAGES: TypedDocumentNode<
  GetMessagesQuery,
  GetMessagesQueryVariables
> = gql`
  ${MESSAGE_FIELDS}
  query GetMessages($input: MessagesQueryInput) {
    messages(input: $input) {
      ...MessageFields
      childMessages {
        ...MessageFields
      }
    }
  }
`;
